import React, { useEffect, useRef } from 'react';
import './App.css';
import { Outlet, useNavigate } from 'react-router-dom';
import Header from './header/Header';
import { Provider, useSelector } from 'react-redux';
import { store } from './store';
import axios from 'axios';
import {
    selectIsAuthenticated,
    selectIsSsoUser,
    selectUserGroupement,
} from './selectors/userSelectors';

function App() {
    const navigate = useNavigate();
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const isSsoUser = useSelector(selectIsSsoUser);
    const groupement = useSelector(selectUserGroupement);
    const hasNavigatedRef = useRef(false);

    // Initialize LBI Chat (only for authenticated users)
    useEffect(() => {
        const initChat = async () => {
            try {
                const response = await axios.get('/api/chat/token');
                if (response.data.success && !document.querySelector('lbi-chat')) {
                    const chatElement = document.createElement('lbi-chat');
                    chatElement.setAttribute('software-name', 'Previsite');
                    chatElement.setAttribute('intelligence-product', 'Previsite');
                    chatElement.setAttribute(
                        'suggestions',
                        JSON.stringify([
                            {
                                icon: 'IconQuestionMark',
                                description: 'Comment créer une publication depuis News Factory ?',
                            },
                            {
                                icon: 'IconQuestionMark',
                                description: 'Comment consulter les articles News Factory ?',
                            },
                            {
                                icon: 'IconQuestionMark',
                                description:
                                    'Pourquoi répondre aux avis de mes clients depuis News Factory ?',
                            },
                        ]),
                    );
                    chatElement.setAttribute('language', 'fr');
                    chatElement.setAttribute('logo', '/picto-newsfactory.svg');
                    chatElement.setAttribute('icon', '/picto-newsfactory.svg');
                    chatElement.setAttribute('token', response.data.token);
                    chatElement.setAttribute('refetch-token', 'refetchToken');
                    document.body.appendChild(chatElement);
                }
            } catch (error) {
                console.error('Failed to initialize chat:', error);
            }
        };

        // Only initialize chat if user is authenticated
        if (isAuthenticated) {
            initChat();
        }

        return () => {
            const chatElement = document.querySelector('lbi-chat');
            if (chatElement) {
                chatElement.remove();
            }
        };
    }, [isAuthenticated]);

    useEffect(() => {
        if (hasNavigatedRef.current) return;

        if (!isSsoUser && groupement?.id === 1) {
            navigate(isAuthenticated ? '/dashboard' : '/login');
            hasNavigatedRef.current = true;
        } else if (isSsoUser) {
            navigate(isAuthenticated ? '/dashboard_agency' : '/login');
            hasNavigatedRef.current = true;
        } else if (groupement !== undefined && groupement.id !== 1 && !isSsoUser) {
            navigate(isAuthenticated ? '/dashboard_admin' : 'login');
            hasNavigatedRef.current = true;
        } else {
            navigate('login');
            hasNavigatedRef.current = true;
        }
    }, [navigate, isAuthenticated, isSsoUser, groupement]);

    return (
        <Provider store={store}>
            <div className="app">
                <Header />
                <Outlet />
            </div>
        </Provider>
    );
}

export default App;
